module.exports = __webpack_public_path__ + "img/verwaltung.41ed9211.svg";